var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.13,
    viewBox: "0 0 20 17.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M40,28.57H25.714l4.7-4.7A1.429,1.429,0,0,0,28.4,21.841l-6.129,6.143A2.857,2.857,0,0,0,21.429,30h0a2.857,2.857,0,0,0,.843,2L28.4,38.141a1.429,1.429,0,0,0,2.014-2.029l-4.7-4.686H40a1.429,1.429,0,1,0,0-2.857Z",
    transform: "translate(-21.429 -21.426)",
    fill: "#e23744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconBlue);
export default __webpack_public_path__ + "static/media/backIconBlue.cb66e81ef8758af854a9800e7f13880b.svg";
export { ForwardRef as ReactComponent };